(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c_access-shop"] && !Shopify.designMode) return;
  try {
    
jQuery(function ($) {
  jQuery(".c_topFaq-item").on("click", function () {
    jQuery(this).toggleClass("js-open");
    jQuery(this).children(".c_topFaq-answer").slideToggle();
    return false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_reserve-faq"] && !Shopify.designMode) return;
  try {
    
jQuery(".c_reserveFaq-item").on("click", function (e) {
  if ($(e.target).closest('a').length) {
    return;
  }
  e.stopPropagation();
  jQuery(this).toggleClass("js-open");
  jQuery(this).children(".c_reserveFaq-answer").slideToggle();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_reserve-main"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  const radioButtons = document.querySelectorAll('input[name="contact[食事内容]"]');
  const applicantCount = document.getElementById('applicantCount');

  const menuLimits = {
    'menuOption5': { min: 2, max: 30 },         // 松花堂弁当
    'menuOption6': { min: 2, max: 30 },    // 会席料理¥4,950
    'menuOption7': { min: 2, max: 30 },    // 会席料理¥6,600
    'menuOption8': { min: 2, max: 10 },    // 会席料理　¥11,000
    'menuOption9': { min: 2, max: 10 }    // 会席料理　¥16,500
  };

  function updateLimits() {
    const selectedOption = document.querySelector('input[name="contact[食事内容]"]:checked');
    if (selectedOption) {
      const limits = menuLimits[selectedOption.id];
      applicantCount.min = limits.min;
      applicantCount.max = limits.max;
      applicantCount.value = Math.max(Math.min(applicantCount.value, limits.max), limits.min);
    }
  }

  radioButtons.forEach(button => {
    button.addEventListener('change', updateLimits);
  });

  applicantCount.addEventListener('input', function() {
    const selectedOption = document.querySelector('input[name="contact[食事内容]"]:checked');
    if (selectedOption) {
      const limits = menuLimits[selectedOption.id];
      if (this.value < limits.min) this.value = limits.min;
      if (this.value > limits.max) this.value = limits.max;
    }
  });

  updateLimits(); // 初期状態を設定


//追加Java Script 11/20
// ▲▼ボタンで人数を増減
const downButton = document.querySelector('.down'); // ▼ボタン
  const upButton = document.querySelector('.up');     // ▲ボタン

  function adjustCount(change) {
    const currentValue = parseInt(applicantCount.value, 10) || 0;
    const min = parseInt(applicantCount.getAttribute('min'), 10);
    const max = parseInt(applicantCount.getAttribute('max'), 10);

    let newValue = currentValue + change;

    if (newValue < min) newValue = min;
    if (newValue > max) newValue = max;

    applicantCount.value = newValue; // 新しい値を設定
  }

  // ボタンにイベントリスナーを追加
  if (downButton && upButton) {
    downButton.addEventListener('click', function() {
      adjustCount(-1);
    });

    upButton.addEventListener('click', function() {
      adjustCount(1);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_top-faq"] && !Shopify.designMode) return;
  try {
    
jQuery(".c_topFaq-item").on("click", function (e) {
  if ($(e.target).closest('a').length) {
    return;
  }
  e.stopPropagation();
  jQuery(this).toggleClass("js-open");
  jQuery(this).children(".c_topFaq-answer").slideToggle();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
